import * as React from 'react';
import { CPairingDevice } from './pairingdevice';
import { Localize, LocalizeReact } from 'shared/utils/localization';
import * as SVG from '../ui/svg_library';

export class CPairingDeviceViveWand extends CPairingDevice
{

	public renderControllerImage( bHighlightPairingControls: boolean ): JSX.Element
	{
		return ( SVG.PairingUIIcon_Wand( bHighlightPairingControls ) );
	}

	protected get pairingInstructions(): JSX.Element
	{
		return ( <div>
					<p>{ LocalizeReact( "#pairing_knuckles_instructions_press",
						<span className="Highlight Capitalize">{ Localize( '#pairing_button_menu' ) }</span>,
						<span className="Highlight Capitalize">{ Localize( '#pairing_button_system' ) }</span> ) }
					</p>
				</div>
		);
	}

	public get className(): string
	{
		return "ViveWand";
	}

	public get controllerName(): string
	{
		return Localize( "#pairingdevice_vivewand_shortname" );
	}

	public get aControllerName(): string
	{
		return Localize( "#pairingdevice_a_vivewand_shortname" );
	}

}
